import React from 'react';
import Navigation from "../components/Navigation/Navigation"
const StaticDarkNavLayout = (props) => (
    <>
        <Navigation staticPosition={true} light={true} />
        <div>{props.children}</div>
    </>
);

export default StaticDarkNavLayout;